import Api from './api';

const ComponentesService = {
    cadastro: async (params) => {
        const response = await Api.post('/componentes/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    cadastroMultiplo: async (params) => {
        const response = await Api.post('/componentes/cadastrar-multiplos', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/componentes/listar',
            params: params
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/componentes/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    compEdit: async (id) => {
        const response = await Api.get(`/componentes/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/componentes/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    }
}

export default ComponentesService;